class HtmlVideoElement {
  static get HAVE_NOTHING() { return 0; }
  static get HAVE_METADATA() { return 1; }
}

if( typeof window.HTMLVideoElement === "undefined" ){
  module.exports = HtmlVideoElement;
}else{
  module.exports = window.HTMLVideoElement;
}

